export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'orderNo',
    align: 'center',
    fixed: 'left',
    width: 150,
    title: '订单编号',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'orderNo',
    },
  },
  {
    field: 'custShortName',
    title: '客户',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orderTime',
    align: 'center',
    width: 170,
    title: '订单时间',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orderStatusName',
    title: '订单状态',
    headerAlign: 'center',
    align: 'center',
    width: 95,
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'v_orderBizStatus',
    title: '订单业务状态',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'orderType',
    title: '订单类型',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'bizType',
    title: '业务类型',
    headerAlign: 'center',
    align: 'center',
    width: 95,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'transportMode',
    title: '运输模式',
    headerAlign: 'center',
    align: 'center',
    width: 95,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originName',
    title: '发货方',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originProvinceName',
    title: '发货省份',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originCityName',
    title: '发货城市',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originDistrictName',
    title: '发货区县',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originPlace',
    title: '发货地址',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationName',
    title: '收货方',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationProvinceName',
    title: '收货省份',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationCityName',
    title: '收货城市',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationDistrictName',
    title: '收货区县',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationPlace',
    title: '收货地址',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleTotalQty',
    title: '车辆总数量',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsName',
    title: '货物名称合集',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsQty',
    title: '总件数',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsWeight',
    title: '总收入重量KG',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsVolume',
    title: '总收入体积m³',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },

  {
    field: 'factWeight',
    title: '总支出重量KG',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'factVolume',
    title: '总支出体积m³',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsValue',
    title: '总货值',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'incomeTotalAmount',
    title: '费用总收入',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'payTotalAmount',
    title: '费用总支出',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orderProfit',
    title: '毛利',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: '费用收入明细',
    headerAlign: 'center',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    children: that.incomeColumnList,
  },
  {
    title: '费用支出明细',
    headerAlign: 'center',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    children: that.payColumnList,
  },
  {
    field: 'builderTime',
    align: 'center',
    width: 170,
    title: '生成时间',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
